export const ReportType = [
    { value: "analitico", name: "Analítico" },
    { value: "sintetico", name: "Sintético" },
];